import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { colors } from '_styles';

import { useHistory, useParams } from 'react-router-dom';
import { setHelpDamagedCartData as setHelpDamagedCartDataAction } from '../../redux/actions';
import getNextActiveScreen from '../../helpers';

const Container = styled.div`
  width: 80%;
  margin: auto;
  padding: 20px;
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Btn = styled.button`
  position: relative;
  font-size: 14px !important;
   
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
`;

const Input = styled.input`
    width: 100%;
    height: 50px;
    display: block;
    padding: 0 10px;
    border-radius: 3px;
    margin-bottom: 15px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
`;

const BinNumberPage = ({
  data, url, damaged_cart_data, damaged_cart_form_data, setHelpDamagedCartData
}) => {
  const [binNumber, setBinNumber] = useState(damaged_cart_form_data?.binNumber || '');
  const { push } = useHistory();
  const { oidx } = useParams();

  const onClick = () => {
    setHelpDamagedCartData({ ...damaged_cart_form_data, binNumber });
    const nextPage = getNextActiveScreen(
      damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
      data.page,
      url
    );
    push(nextPage, {
      damaged_cart_data: damaged_cart_data.find(({ oidx: index }) => index === Number(oidx))
    });
  };

  const onTextChange = ({ target }) => {
    setBinNumber(target.value);
  };

  return (
    <Container>
      <h3>{data?.title}</h3>
      <Input
        id="name"
        type="text"
        onChange={onTextChange}
        value={binNumber}
        placeholder="Bin number"
        onKeyDown={(e) => e.stopPropagation()}
      />
      <BtnContainer>
        <Btn onClick={onClick}>
          Continue
        </Btn>
      </BtnContainer>
    </Container>
  );
};

export default connect(
  (store) => ({
    damaged_cart_data: store?.help?.helpItems.filter(({ type }) => type === 'DAMAGED_CART'),
    damaged_cart_form_data: store?.help?.damagedCartFormData,
  }),
  (dispatch) => ({
    setHelpDamagedCartData: (data) => dispatch(setHelpDamagedCartDataAction(data))
  })
)(BinNumberPage);
